import React, { useState } from 'react';
import NavbarAdmin from '../../../components/navbarAdmin'
import { FaArrowLeft, FaSearch } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom'
import { useFirestore } from '../../../hooks/useFirestore';
import { useAlert } from '../../../contexts/alerta';
import MostraStatus from '../../../components/mostraStatus';
import MostraGravidade from '../../../components/mostraGravidade';
import ModalReposta from '../../../components/modalReposta';
import Tabs from '../../../components/tabs';
import ModalAcompanhamento from '../../../components/modalAcompanhamento';
import ModalFinalizaAcompanhamento from '../../../components/modalFinalizaAcompanhamento';
import ModalTrocaSituacao from '../../../components/modalTrocaSituacao';
import MostraMotivo from '../../../components/mostraMotivo';

export function Relato() {
  const [showModalResposta, setShowModalResposta] = useState(false)
  const [showModalAcompanhamento, setShowModalAcompanhamento] = useState(false)
  const [showModalTrocarSituacao, setShowModalTrocarSituacao] = useState(false)
  const [showModalFinalizaAcompanhamento, setShowModalFinalizaAcompanhamento] = useState(false)
  const [selectedIndexAcompanhamento, setSelectedIndexAcompanhamento] = useState(0)

  const { atualizaRelato } = useFirestore()
  const location = useLocation()
  const { addAlert } = useAlert()
  const nav = useNavigate()

  const relato = location.state.relato

  const handleBack = () => nav('/relatos')

  const handleSubmit = (res) => {
    if (relato.msg === undefined) {
      relato.msg = []
      relato.msg.push(res)
    } else {
      relato.msg.push(res)
    }
    
    atualizaRelato(relato)
      .then(() => {
        addAlert('Relato Respondido com sucesso!', 'success')
        setShowModalResposta(false)
      })
      .catch(() => {
        addAlert('Um problema inesperado ocorreu!', "error")
      })
  }

  const handleSubmitAcompanhamento = (res) => {
    if (relato.acompanhamento === undefined) {
      relato.acompanhamento = []
      relato.acompanhamento.push(res)
    } else {
      relato.acompanhamento.push(res)
    }

    atualizaRelato(relato)
      .then(() => {
        addAlert('Acompanhamento criado com sucesso!', 'success')
        setShowModalAcompanhamento(false)
      })
      .catch(() => {
        addAlert('Um problema inesperado ocorreu!', "error")
      })
  }

  const handleSubmitFinaliza = (res) => {
    relato.acompanhamento[selectedIndexAcompanhamento] = { ...relato.acompanhamento[selectedIndexAcompanhamento], ...res }

    atualizaRelato(relato)
      .then(() => {
        addAlert('Acompanhamento finalizado com sucesso!', 'success')
        setShowModalFinalizaAcompanhamento(false)
      })
      .catch(() => {
        addAlert('Um problema inesperado ocorreu!', "error")
      })
  }

  const handleSelectAcompanhamento = (index) => {
    setSelectedIndexAcompanhamento(index)
    setShowModalFinalizaAcompanhamento(true)
  }


  const handleTrocaSituacao = (res) => {
    relato.status = res.status
    relato.gravidade = res.gravidade
    relato.procedencia = res.procedencia
    relato.alteradoPor = res.alteradoPor
    
    atualizaRelato(relato)
      .then(() => {
        addAlert('Situação do relato alterada com sucesso!', 'success')
        setShowModalTrocarSituacao(false)
      })
      .catch(() => {
        addAlert('Um problema inesperado ocorreu!', "error")
      })
  }

  const showMsg =
    <div className='mt-4'>
      {
        relato.msg !== undefined && relato.msg.length > 0 ?
          <>
            {relato.msg.map((msg, i) =>
              <div className="bg-background mt-4 mb-4 p-4 text-secondary" key={i}>
                <span><i>Por: {msg.respondidoPor} - {new Date(msg.respondidoEm).toLocaleString()}</i></span>
                <p><b>{msg.mensagem}</b></p>
                {
                  msg.respostaAnexos !== undefined && msg.respostaAnexos.length > 0 ?
                    <div className='flex flex-col'>
                      <h1>Anexos:</h1>
                      {
                        msg.respostaAnexos.map((anexo, index) => (
                          <a href={anexo.arquivo} key={index} download className='font-semibold underline text-primary'>
                            {anexo.nomeArquivo}
                          </a>
                        ))
                      }
                    </div>
                    :
                    <></>
                }
              </div>
            )
            }
          </>
          :
          <div className='text-secondary'>Este relato não possui mensagens.</div>
      }
    </div>

  const showAcompanhamento =
    <div className='flex flex-col gap-4 mt-4'>
      {
        relato.acompanhamento !== undefined && relato.acompanhamento.length > 0 ?
          <>
            {relato.acompanhamento.map((msg, i) => {
              return (
                <div className="border-b-2 border-b-primary mt-4 mb-4 p-4 text-secondary" key={i}>
                  <div className='flex justify-between'>
                    <span className='text-primary'><i>Por: {msg.criadoPor} - {new Date(msg.criadoEm).toLocaleString()}</i></span>
                    <span title={'Alterado em: ' + new Date(msg.alteradoEm).toLocaleString()}><i><MostraStatus status={msg.status} lang={'ptbr'} /></i></span>
                  </div>
                  <p className='text-primary'><i>Para: {msg.responsavel}</i></p>
                  <div className='mt-4'>
                    <span className='text-primary'><b>Ação: </b></span>
                    <p>{msg.acao}</p>
                  </div>
                  {
                    msg.status === 'EM_ANDAMENTO' ?
                      <div className='flex justify-end'>
                        <button className='bg-primary px-2 py-1 rounded text-white active:bg-opacity-90' onClick={() => handleSelectAcompanhamento(i)}>Finalizar Acompanhamento</button>
                      </div>
                      :
                      <div className='mt-4'>
                        <span className='text-primary'><b>Observação: </b></span>
                        <p>{msg.observacao}</p>
                      </div>
                  }
                </div>
              )
            })}
          </>
          :
          <div className='text-secondary'>Este relato não possui acompanhamento interno.</div>
      }
    </div>
    
  const abas = [
    { id: 0, label: 'Histórico de Mensagens', content: showMsg },
    { id: 1, label: 'Acompanhamento', content: showAcompanhamento }
  ]

  return (
    <div >
      <NavbarAdmin />
      <main >
        <section className='lg:w-4/6 md:w-5/6 w-11/12 mx-auto mt-8'>
          <div className='flex justify-between mb-8'>
            <h1 className='flex text-primary items-center text-3xl gap-4 font-semibold'><FaSearch />ACOMPANHAR RELATO</h1>
            <button className='flex items-center text-base text-secondary gap-2 font-semibold' onClick={handleBack}>
              <FaArrowLeft />
              <span className='hidden lg:block'>VOLTAR</span>
            </button>
          </div>
          <hr className='border-background mb-8' />
          <div className='text-secondary flex flex-col gap-4'>
            <div className="flex justify-between items-center flex-col lg:flex-row gap-4">
              <span className='flex items-center gap-2'>Numero do protocolo: <b>{relato.uuid}</b><MostraGravidade gravidade={relato.gravidade}/></span>
              <span>Possui Procedência: {relato.procedencia ? 'Sim' : 'Não' }</span>
              <span className='flex items-center'><b>STATUS:</b> <MostraStatus status={relato.status} lang={'ptbr'} /></span>
            </div>
            <div className='flex justify-between flex-col gap-4 lg:flex-row'>
              <span>Aberto em <b>{new Date(relato.criadoEm).toLocaleString()}</b></span>
              <span>Atualizado em <b>{new Date(relato.alteradoEm).toLocaleString()}</b></span>
              <span>Expira em <b>{new Date(relato.expiraEm).toLocaleString()}</b></span>
            </div>
            {
              relato.nome !== '' &&
              <div className="flex justify-between flex-col gap-4 lg:flex-row">
                <span>Nome: <b>{relato.nome}</b></span>
                <span>E-mail: <b>{relato.email}</b></span>
                <span>Telefone: <b>{relato.telefone}</b></span>
              </div>
            }
            <div className="flex flex-col gap-1 mt-2">
              <div className='flex capitalize gap-1 text-primary' style={{ width: '35%' }}>Motivo:
                <span id='motivo' name='motivo'><b><MostraMotivo motivo={relato.motivo} lang={'pt'}/></b></span>
              </div>
              <div className='flex p-4 flex-col bg-background'>
                Detalhamento:
                <span id='relato' name='relato'><b>{relato.relato}</b></span>
              </div>
            </div>
            {
              relato.anexos !== undefined && relato.anexos.length > 0 ?
                <div className="flex flex-col gap-4">
                  <span className='font-semibold text-xl text-primary'>Anexos:</span>
                  {
                    relato.anexos.map((anexo, i) => {
                      return <a href={anexo.arquivo} key={i} download className='font-semibold underline'>
                        {anexo.nomeArquivo}
                      </a>
                    })
                  }
                </div>
                :
                <></>
            }
          </div>
          <Tabs tabs={abas} />
          <hr className='border-background shadow mb-8 mt-8' />
          <div className='flex mb-32 justify-between'>
            <button className='bg-primary px-4 py-2 text-white rounded-md' type="button" onClick={() => setShowModalResposta(true)}>Nova Mensagem</button>
            <button className='bg-primary px-4 py-2 text-white rounded-md' type="button" onClick={() => setShowModalAcompanhamento(true)} >Acompanhamento Interno</button>
            <button className='bg-primary px-4 py-2 text-white rounded-md' type="button" onClick={() => setShowModalTrocarSituacao(true)} >Trocar Situação</button>
          </div>
        </section>
        {
          showModalResposta &&
          <ModalReposta submit={handleSubmit} close={setShowModalResposta} />
        }
        {
          showModalAcompanhamento &&
          <ModalAcompanhamento submit={handleSubmitAcompanhamento} close={setShowModalAcompanhamento} />
        }
        {
          showModalTrocarSituacao &&
          <ModalTrocaSituacao submit={handleTrocaSituacao} close={setShowModalTrocarSituacao} procedente={relato.procedencia} />
        }
        {
          showModalFinalizaAcompanhamento &&
          <ModalFinalizaAcompanhamento submit={handleSubmitFinaliza} close={setShowModalFinalizaAcompanhamento} />
        }
      </main>
    </div>
  )
};
